module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    staticClass: "md4",
    attrs: {
      "label": "Audience Name",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "items": _vm.sortedOptions,
      "item-text": "Name",
      "item-value": "Value",
      "id": "appendFileModalAudienceNameSelect",
      "search-input": _vm.search,
      "return-object": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.update(val); },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d0cea1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/TargetDDL.vue
// module id = 1811
// module chunks = 0